
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';

/**
 * Guard to redirect routes that contain unexpected extra URL segments.
 *
 * Prevents navigation when an extra route parameter named 'anything' is present
 * and redirects the user to the '/set-password' route.
 */
@Injectable({ providedIn: 'root' })
export class SetPasswordGuard implements CanActivate {
    constructor(private router: Router) { }
    /**
     * Determine whether the route can be activated.
     *
     * If the activated route contains a param named 'anything', navigation is
     * cancelled and the user is redirected to '/set-password'.
     *
     * @param route The current activated route snapshot
     * @returns True to allow activation, false to cancel and redirect
     */
    canActivate(route: ActivatedRouteSnapshot): boolean {

        // Check if there is any extra segment
        if (route.params['anything']) {
            this.router.navigate(['/set-password']);
            return false;
        }
        return true;
    }
}
